<p>promotion-code works!</p>
